import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserName } from '@core/customer-space-admin/customer-space-user.model';

@Component({
  selector: 'app-display-user-info',
  template: `
    <strong>{{ userName.firstName }} {{ userName.lastName }}</strong>
    <div>{{ userName.roleText }}</div>
    <span *ngIf="userName.roleDescription">{{ userName.roleDescription }}</span>
    <div *ngIf="userName.isContact">
      {{ 'customer-spaces.user-management.contact' | translate }}
    </div>
    <div *ngIf="userName.isDeputy" class="mt-20">{{ 'users.user-profile.deputy-from' | translate }} {{ userName.deputyFromName }}</div>
  `,
  styles: [
    `
      :host {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DisplayUserInfoComponent {
  @Input() userName!: UserName;
}
